<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>设备列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="toolbar-box">
        <div class="list-box">
          <div class="r-list">
            <div class="option">
              <cn-select-search
                v-model="companyId"
                :v_disabled="disabled"
                :v_whole="true"
                :data="companyList"
                @val="setCompanyId"
                placeholder="请筛选客户..."
              >
              </cn-select-search>

              <el-select v-model="modelId" placeholder="请选择型号...">
                <el-option :key="0" label="全部型号" :value="0"></el-option>
                <el-option
                  v-for="item in cabinetModelList"
                  :key="item.id"
                  :label="item.modelName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select v-model="stateType" placeholder="请选择在线状态...">
                <el-option
                  v-for="(item, index) in stateList"
                  :key="index"
                  :label="item.label"
                  :value="item.state"
                >
                </el-option>
              </el-select>
              <el-select v-model="onlineType" placeholder="请选择运行状态...">
                <el-option
                  v-for="item in onlineLists"
                  :key="item.online"
                  :label="item.label"
                  :value="item.online"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-box">
              <el-input placeholder="输入设备编号，关健字" v-model="keyword">
                <el-button
                  type="primary"
                  slot="append"
                  icon="el-icon-search"
                  @click="initDataSelect"
                ></el-button>
              </el-input>
            </div>
            <div class="btn-box" v-show="false">
              <el-button-group>
                <el-button
                  type="primary"
                  :icon="iconToolsBar"
                  @click="toggleToolsBar"
                ></el-button>
              </el-button-group>
            </div>
            <div class="search-box">
              <el-button
                type="primary"
                @click="toggleChage"
                style="float: right"
                >切换列表</el-button
              >
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="top-box">
				<h1>{{companyName}}</h1>
				<h2>{{dateTime}}</h2>
			</div> -->

      <div class="content-box" style="padding-top: 20px">
        <div class="cabinet-list" v-loading="loading">
          <el-card v-if="listData.length == 0" class="nodata">暂无数据</el-card>
          <el-card
            v-for="(item, index) in listData"
            :key="index"
            class="cabinet-box"
          >
            <div style="cursor: pointer" @click="cabinetShow(item)">
              <div class="companyName">
                <span
                  class="online_style"
                  :style="{ background: onlineColor[item.online] }"
                  >{{ onlineList[item.online] }}</span
                >
                | {{ item.companyName }}
                <span
                  class="r_radius"
                  v-if="item.state == 1"
                  style="background: #909399"
                ></span>
                <span
                  class="r_radius"
                  v-else-if="item.state == 3"
                  style="background: red"
                ></span>
                <span
                  class="r_radius"
                  v-else
                  style="background: #67c23a"
                ></span>
              </div>
              <div class="state">
                <span v-if="item.state == 1">空闲</span>
                <span v-else-if="item.state == 3">故障</span>
                <span v-else-if="item.state == 4">充电中</span>
                <span v-else-if="item.state == 5">放电中</span>
                <span v-else>空闲</span>
              </div>

              <div class="label" style="line-height: 30px">
                <span class="l l_flex">编号：{{ item.cabinetCode }}</span>
                <span class="l l_flex">标签：{{ item.cabinetName }}</span>
              </div>

              <div class="label" style="line-height: 30px">
                <span class="l"
                  >电量：<span class="progress_bar"
                    ><p :style="{ width: item.soc + '%' }"></p></span
                  >{{ item.soc }}%</span
                >
              </div>
              <div class="label" style="line-height: 30px">
                <span class="r l_flex">温度：{{ item.temp }} ℃</span>
                <span class="l l_flex">型号：{{ item.modelName }}</span>
              </div>

              <div class="label" style="line-height: 30px">
                <span class="l l_flex"
                  >峰充：{{ item.chargeStatistic.peakChargePower || 0 }}</span
                >
                <span class="l l_flex"
                  >峰放：{{
                    item.chargeStatistic.peakDischargePower || 0
                  }}</span
                >
              </div>
              <div class="label" style="line-height: 30px">
                <span class="l l_flex"
                  >平充：{{ item.chargeStatistic.flatChargePower || 0 }}</span
                >
                <span class="l l_flex"
                  >平放：{{
                    item.chargeStatistic.flatDischargePower || 0
                  }}</span
                >
              </div>
              <div class="label" style="line-height: 30px">
                <span class="l l_flex"
                  >谷充：{{ item.chargeStatistic.valleyChargePower || 0 }}</span
                >
                <span class="l l_flex"
                  >谷放：{{
                    item.chargeStatistic.valleyDischargePower || 0
                  }}</span
                >
              </div>
            </div>
          </el-card>
        </div>

        <div class="pager-box" v-show="totalCount > 100">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
import "../../js/select.component.js";
export default {
  data() {
    return {
      disabled: false,
      companyList: [],
      companyId: "",
      modelId: "",
      cabinetModelList: [],
      iconToolsBar: "iconfont icon-d-arrow-down", //更多按钮图标
      onlineList: ["离线", "在线", "未知"],
      onlineColor: ["red", "#67c23a", "#909399"],

      dateTime: "",
      companyName: "深圳市富鑫产业科技有限公司",
      loading: false,
      keyword: "",
      totalCount: 0,
      pageSize: 100,
      pageIndex: 1,
      listData: [],
      setTime: "",
      stateList: [
        { state: "1", label: "空闲" },
        { state: "3", label: "故障" },
        { state: "4", label: "充电" },
        { state: "5", label: "放电" },
      ],
      stateType: "",
      onlineLists: [
        { online: "0", label: "离线" },
        { online: "1", label: "在线" },
      ],
      onlineType: "",
    };
  },
  mounted() {},
  methods: {
    //切换更多查询条件
    toggleToolsBar: function () {
      this.showToolsBar = !this.showToolsBar;
      if (this.showToolsBar) {
        this.heightToolsBar = "height:auto";
        this.iconToolsBar = "iconfont icon-d-arrow-up";
      } else {
        this.heightToolsBar = "height:60px";
        this.iconToolsBar = "iconfont icon-d-arrow-down";
      }
    },
    setCompanyId: function (obj) {
      this.companyId = obj.toString();
      const _this = this;
      // 获取公司设备
      AxiosAjax({
        url: "/cabinet/cabinet/search?companyId=" + _this.companyId,
        success: function (res) {
          _this.cabinetModelList = res.data.data;
        },
      });
    },
    toggleChage() {
      this.$router.push({ name: "CabinetCabinetList" });
    },
    initDataSelect() {
      this.initData();
    },
    //加载数据
    initData: function () {
      let _this = this;
      _this.companyList = getCompanyData();
      // _this.cabinetModelList = getModelData();

      if (this.companyId == 0) {
        _this.companyId = "";
      }
      console.log(this.companyId);

      let sendUrl = "/cabinet/cabinet/page/v2";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      if (_this.keyword.length > 0) {
        sendUrl += "&cabinetCodeLike=" + encodeURI(_this.keyword);
        // sendUrl += "&companyNameLike=" + encodeURI(_this.keyword);
      }
      if (_this.companyId.length > 0) {
        sendUrl += "&companyId=" + _this.companyId;
      }

      if (_this.modelId.length > 0) {
        sendUrl += "&modelId=" + _this.modelId;
      }
      if (_this.stateType.length > 0) {
        sendUrl += "&state=" + _this.stateType;
      }
      if (_this.onlineType.length > 0) {
        sendUrl += "&online=" + _this.onlineType;
      }

      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          res.data.data.content.forEach((item) => {
            if (item.chargeStatistic == null) {
              item.chargeStatistic = {
                peakChargePower: 0,
                flatChargePower: 0,
                valleyChargePower: 0,
                peakDischargePower: 0,
                flatDischargePower: 0,
                valleyDischargePower: 0,
              };
            }
          });

          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    cabinetShow: function (item) {
      // this.$router.push({name: 'CabinetShow', query: {id: _id}});
      this.$router.push({
        name: "CabinetDetails",
        query: {
          id: item.id,
          companyId: item.companyId,
          cabinetCodes: item.cabinetCode,
          companyIdReturn: this.companyId,
        },
      });
    },
    //跳转链接
    linkUrl: function (url) {
      window.location.href = url;
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },
  },
  created: function () {
    var _this = this;
    this.companyId = _this.$route.query.companyId || ""; //获取ID

    //加载数据
    _this.initData();
    _this.setTime = setInterval(() => {
      _this.initData();
    }, 120000);
    window.setInterval(function () {
      _this.dateTime = new Date(new Date()).pattern("yyyy-MM-dd HH:mm:ss");
    }, 1000);
  },
  destroyed() {
    const _this = this;
    clearInterval(_this.setTime);
  },
};
</script>
<style scoped>
.online_style {
  display: inline-block;
  padding: 2px 14px;
  border-radius: 10px;
  color: #fff;
}
.top-box {
  background-color: #0f5195;
  color: #fff;
  height: 50px;
  line-height: 50px;
}
.top-box h1 {
  float: left;
  padding-left: 10px;
}
.top-box h2 {
  float: right;
  padding-right: 10px;
}
.content-box .cabinet-list {
  margin: 0 -20px 0 0;
  display: flex;
  flex-flow: row wrap;
  justify-content: start;
  min-height: 40px;
}
.content-box .cabinet-list .cabinet-box {
  position: relative;
  padding: 0 10px;
  margin: 0 20px 20px 0;
  width: 298px;
  max-width: 298px;
  flex-grow: 1;
  border: 1px solid #d4e9ff;
  text-align: left;
}
.progress_bar {
  display: inline-block;
  width: 140px;
  height: 10px;
  border: 1px solid #d4e9ff;
  margin-right: 14px;
  padding: 0;
}
.progress_bar > p {
  height: 10px;
  background: #67c23a;
}
.content-box .cabinet-list .cabinet-box .el-card__body {
  padding: 0;
}
.content-box .cabinet-list .cabinet-box .companyName {
  font-weight: bold;
  padding: 0px 0px 5px;
  margin-bottom: 5px;
}
.content-box .cabinet-list .state {
  display: inline-table;
  padding: 6px 8px 6px 0;
  overflow: hidden;
}
.content-box .cabinet-list .label {
  margin: 0px;
  padding: 6px 0 6px 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  line-height: 20px;
}
.content-box .cabinet-list .label .l_flex {
  flex: 1;
}
.content-box .cabinet-list .label .l {
  font-size: 14px;
  line-height: 20px;
}

.content-box .cabinet-list .label .r {
  font-size: 14px;
  line-height: 20px;
}
.r_radius {
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  position: absolute;
  right: 20px;
  top: 20px;
}
.el-pagination__total {
  color: #ffffff;
}
.el-pagination__jump {
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/Monitor/CabinetList.vue